/* global System */
// register component(s) with react habitat

export default { History: () => System.import('./index') }
